import * as React from "react";

import { AppContext } from "@1js/acui-context";
import { checkExperiment, ribbonExperiments } from "@1js/acui-experiments";

/** Checks if the new tablist experiment is enabled */
export const useNextRibbonTabListEnabled = () => {
  const appContext = React.useContext(AppContext);
  return checkExperiment(
    appContext,
    ribbonExperiments.fluentV9TabListSpinButtonFocusIsEnabled
  );
};
